/**
 * orga-app-api - qschecks-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PrueflaufAntwort { 
    pruefaufgabe_id: string;
    pruefcheckliste_id: string;
    beschreibung?: string;
    farbe?: string;
    gewichtung?: number;
    icon?: string;
    ist_gewaehlt?: boolean;
    ist_na?: boolean;
    ist_ne?: boolean;
    ist_zulaessig?: boolean;
    kuerzel?: string;
    antwort_id: string;
    modified_on_utc?: Date;
}

